import { CreateElement } from 'vue'
import { Route, RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import * as TYPES from '@/helpers/enums/view-types'
import { VPR_PUBLICATIONS_PAGES_ROUTES as ROUTES } from './utils'
import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as VPR_PUBLICATIONS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'vpr-publications',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        './store'
      )
      registerModule(options)
      const { registerModule: handbookRegisterModule } = await import(
        '@/views/FormsHandbook/store/cache'
      )
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'view-vpr-publications-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        component: (): PromiseVue => import(
          './VPRPublicationsList.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          './VPRPublicationsView.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          './VPRPublicationsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
